import { Button, Dialog, DialogActions, DialogContent, DialogContentText, Typography, useTheme } from "@mui/material";
import { useState } from "react";

interface IGameDialog {
  open: boolean;
  toggleDialog?: () => void;
  title?: string;
  classes?: any;
  onConfirm?: () => void;
  message?: string;
  buttonText?: string;
  children?: React.ReactNode;
  disableBackdropClick?: boolean;
  disableEscapeKeyDown?: boolean;
  isMobile?: boolean;
  isFullscreen?: boolean;
}

export default ({
  open,
  toggleDialog,
  title,
  classes = {},
  onConfirm = () => {},
  message = "",
  buttonText = "Ok",
  children,
  disableBackdropClick = false,
  disableEscapeKeyDown = false,
  isMobile = false,
  isFullscreen = false,
}: IGameDialog) => {
  const theme = useTheme();
  const [isOpen, setIsOpen] = useState(open);

  const isFullscreen_ = isFullscreen || isMobile;

  return (
    <Dialog
      open={isOpen}
      sx={{
        height: "100%",
        width: "100%",
        position: "absolute",
        zIndex: "100",
        maxWidth: "100vw",
        backgroundSize: "cover",
        ...(classes.dialog || {}),
        "& .MuiDialog-paper": {
          maxWidth: "100vw",
          borderRadius: theme.spacing(1.25),
          position: "relative",
          backdropFilter: `blur(${theme.spacing(1.25)})`,
          backgroundColor: `${theme.palette.dsBase.v100}95`,
          border: `1px solid ${theme.palette.dsSurface.v400}80`,
          ...(classes.paper || {}),
          ...(isFullscreen_
            ? {
                maxHeight: "100vh",
                width: "100vw",
                height: "100vh",
                margin: 0,
              }
            : {}),
        },
      }}
      disableEscapeKeyDown={disableEscapeKeyDown}
    >
      {title ? (
        <Typography
          id="alert-dialog-title"
          sx={{
            color: theme.palette.dsBase.v200,
            fontSize: theme.spacing(4),
            marginLeft: theme.spacing(3),
            marginTop: theme.spacing(1.5),
          }}
        >
          {title}
        </Typography>
      ) : null}
      <DialogContent>{children ? children : <DialogContentText id="alert-dialog-description">{message}</DialogContentText>}</DialogContent>
      {buttonText ? (
        <DialogActions
          sx={{
            "& .MuiDialogActions-root": {
              justifyContent: "center",
            },
          }}
        >
          <Button
            color="error"
            variant="outlined"
            onClick={() => {
              onConfirm();
              setTimeout(() => {
                toggleDialog?.();
              }, 100);
              setIsOpen(false);
            }}
            sx={{
              "& .MuiButton-root": {
                width: theme.spacing(24),
                backgroundColor: "transparent",
                color: theme.palette.dsPrimary.v200,
                border: "none",
                fontSize: theme.spacing(2.5),
                borderRadius: 0,
                "&:hover": {
                  backgroundColor: "transparent",
                  color: theme.palette.dsPrimary.v200,
                  border: "none",
                },
                marginBottom: theme.spacing(5),
                ...classes.buttonRoot,
              },
            }}
          >
            {buttonText}
          </Button>
        </DialogActions>
      ) : null}
    </Dialog>
  );
};
